<template>
  <div>
    <b-form>
      <b-form-group
        id="input-group-1"
        :label="$t('text_announcement_form.subject')"
        label-for="input-1"
      >
        <b-form-input
          :disabled="false"
          id="input-1"
          v-model="form.otsikko"
          required
          :placeholder="$t('text_announcement_form.subject')"
        ></b-form-input>
      </b-form-group>

      <!--
      <b-card id="announcementImageDiv">
        <AnnouncementImage v-if="this.imgTunnus != -1" :imageid="this.imgTunnus"></AnnouncementImage>
        <b-icon icon="image" style="color: #E8E8E8;" font-scale="10.5" v-if="form.tunnus == -1"></b-icon>
      </b-card>
      -->
      <div id="announcementImageDiv">
        <AnnouncementImage
          v-if="this.imgTunnus != -1"
          :imageid="this.imgTunnus"
        ></AnnouncementImage>
        <b-icon
          icon="image"
          style="color: #e8e8e8; margin-top: 30px"
          font-scale="10.5"
          v-if="form.tunnus == -1"
        ></b-icon>
      </div>

      <b-form-group
        :label="$t('text_announcement_form.file')"
        label-for="file-small"
        label-cols-sm="2"
      >
        <b-form-file
          v-model="imgFile"
          :disabled="false"
          id="file-small"
          :browse-text="$t('file.browse')"
          :placeholder="$t('file.no_file')"
        ></b-form-file>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import announcements from '@/store/announcements/announcements'

import AnnouncementImage from '@/components/Announcements/AnnouncementImage'

export default {
  name: 'ImgAnnouncementEditForm',
  components: {
    AnnouncementImage,
  },
  props: {
    editordata: Object,
    creatingNew: Boolean,
  },
  data() {
    return {
      systemLangs: [],
      form: {},
      show: true,
      disabled: false,
      uploadFileToken: null,
      imgFile: null,
      imgTunnus: -1,
      defaultFormData: {
        tunnus: -1,
        externalId: null,
        tiedoteTextList: {
          1: null,
        },
        otsikko: '',
        kelpoisuusalkaa: '',
        kelpoisuusloppuu: '',
        tyyppi: 4,
        organisaatio: null,
        htiedoteid: null,
        hstatus: null,
        kiinnitystyyppi: null,
        terminal: null,
        uploadToken: null,
      },
    }
  },
  beforeCreate: function () {
    if (!this.$store.state.announcements) {
      this.$store.registerModule('announcements', announcements)
    }
  },
  created: function () {
    if (this.editordata != null) {
      this.form = JSON.parse(JSON.stringify(this.editordata))
      this.imgTunnus = this.form.tunnus
    } else {
      this.form = JSON.parse(JSON.stringify(this.defaultFormData))
      this.imgTunnus = this.form.tunnus
    }

    this.$store.dispatch('getSystemParameters').then(
      (result) => {
        var langs = []
        Object.keys(result.system_languages).forEach((item) =>
          langs.push({ id: item, lang: result.system_languages[item] })
        )
        this.systemLangs = langs
      },
      () => {
        this.$travellerGetDataError()
      }
    )
  },
  watch: {
    editordata: function () {
      if (this.editordata == null) {
        this.resetForm()
      } else {
        this.form = JSON.parse(JSON.stringify(this.editordata))
        this.imgTunnus = this.form.tunnus
        this.disabled = false
      }
    },
    creatingNew: function () {
      if (this.creatingNew) {
        this.newAnnouncement()
      }
    },
    imgFile: function () {
      if (this.imgFile == null) {
        return
      }
      this.$store
        .dispatch('announcements/sendAnnouncementImage', this.imgFile)
        .then(
          (result) => {
            this.uploadFileToken = result
            this.form.uploadToken = result
          },
          () => {
            this.$travellerGetDataError()
          }
        )
    },
  },
  methods: {
    newAnnouncement: function () {
      this.form = JSON.parse(JSON.stringify(this.defaultFormData))
      this.disabled = false
    },
    resetForm: function () {
      this.form = JSON.parse(JSON.stringify(this.defaultFormData))
      this.imgFile = null
      this.imgTunnus = this.form.tunnus
      this.disabled = false
    },
    collectFormData: function () {
      return JSON.parse(JSON.stringify(this.form))
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div#announcementImageDiv > div {
  width: auto;
  min-width: 10em;
  height: auto;
  min-height: 15em;
  align-self: center;
}

#announcementImageDiv {
  text-align: center;
  margin: 20px 0 20px 0;
  min-height: 15em;
}
</style>
